<example-shell
  exampleId="disabled-selection" [title]="title" [summary]="summary" [dataSnippet]="dataSnippet" [events]="events" (clear)="clearEvents()">
  <stackline-data-table
    title="Locked rows"
    [columns]="lockedColumns"
    [data]="lockedRows"
    [selectableRows]="true"
    [selectableRowsHighlight]="true"
    [selectableRowDisabled]="isLocked"
    [highlightOnHover]="true"
    (selectedRowsChange)="record('disabled selection', $event)">
  </stackline-data-table>
</example-shell>
